export default "__VITE_ASSET__vF5HlwaW__"